<div class="recover-company-name-email-sent">
  <div class="recover-company-name-email-sent__description">{{ 'login.recovery.company-name-email-sent.description' | translate }}</div>

  @if (companyNameRecoveryCredentials(); as companyNameRecoveryCredentials) {
    <div class="recover-company-name-email-sent__content">
      <div class="recover-company-name-email-sent__tooltip-wrapper">
        <itc-table-tooltip tooltipPosition="top-left" [tooltipText]="companyNameRecoveryCredentials.userEmail">
          <span class="recover-company-name-email-sent__email">{{ companyNameRecoveryCredentials.userEmail }}</span>
        </itc-table-tooltip>
      </div>
    </div>
  }
</div>
